export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, shrink-to-fit=no"}],"link":[],"style":[],"script":[{"id":"matomo-tagmanager","data-cookieconsent":"ignore","innerHTML":"\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){ dataLayer.push(arguments); }\n          gtag('consent', 'default', {\n            ad_storage: 'denied',\n            ad_user_data: 'denied',\n            ad_personalization: 'denied',\n            analytics_storage: 'denied',\n            functionality_storage: 'denied',\n            personalization_storage: 'denied',\n            security_storage: 'granted',\n            wait_for_update: 2000\n          });\n          gtag('set', 'ads_data_redaction', true);\n          gtag('set', 'url_passthrough', true);\n          var _mtm = window._mtm = window._mtm || [];\n          _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});\n          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n          g.async=true; g.src='https://cdn.matomo.cloud/djurensratt.matomo.cloud/container_g5thZTcA.js'; s.parentNode.insertBefore(g,s);","async":true,"type":"text/javascript"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false